import { useCreditUsageItems } from '@aibees/shared/hooks';
import { CreditUsageType } from '@aibees/shared/definition';
import { useMemo } from 'react';
import { CREDIT_CATEGORY_DEFINITIONS } from '../config';
import type { IconName } from '@aibees/shared/components/icon/types';

export interface CreditCategoryRow {
  type: CreditUsageType;
  title: string;
  credit: number;
}

export interface CreditCategoryWithRates {
  title: string;
  icon: IconName;
  rows: CreditCategoryRow[];
}

export function useCreditRateCategories(): {
  categories: CreditCategoryWithRates[];
  isLoading: boolean;
} {
  const { items, isLoading } = useCreditUsageItems();

  const categories = useMemo(() => {
    return CREDIT_CATEGORY_DEFINITIONS.map((def) => ({
      title: def.title,
      icon: def.icon,
      rows: def.types
        .map((type) => {
          const item = items.find((i) => i.type === type);
          if (!item) return null;
          return {
            type,
            title: item.title,
            credit: item.credit,
          };
        })
        .filter((row): row is CreditCategoryRow => row !== null),
    }));
  }, [items]);

  return { categories, isLoading };
}
